<template>
  <div class="title-area">
    <img :src="getImage" />
    <div class="name-area">
      <p class="category">
        {{ selectedSpotCategory }}
      </p>
      <p class="title-name">{{ selectedSpot.name }}</p>
      <div class="star-area" v-if="comments">
        <div class="stars">
          <span
            v-for="(number, index) in [1, 2, 3, 4, 5]"
            :key="index"
            :class="{ colored: number <= stars }"
            >★</span
          >
        </div>
        ({{ comments.length }})
      </div>
    </div>
    <div class="checkin-area">
      <div class="checkin-item">
        <p>
          {{ selectedSpot.CheckIn }}
        </p>
        <p class="unit">チェックイン</p>
      </div>
      <div class="checkin-item">
        <p>
          {{ missionNum }}
        </p>
        <p class="unit">ミッション</p>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonTextLink from "@/components/Atoms/ButtonTextLink";

export default {
  name: "show-review-area",
  components: {
    ButtonTextLink,
  },
  props: {
    selectedSpot: { type: Object, require: true },
    comments: { type: Array, require: true },
  },
  computed: {
    selectedSpotCategory() {
      if (this.selectedSpot.category.id === 1) return "観光";
      else if (this.selectedSpot.category.id === 2) return "温泉";
      else if (this.selectedSpot.category.id === 3) return "食事";
      else if (this.selectedSpot.category.id === 4) return "体験";
      else if (this.selectedSpot.category.id === 5) return "お土産";
      return "";
    },
    missionNum() {
      return this.selectedSpot.missions ? this.selectedSpot.missions.length : 0;
    },
    getImage() {
      if (this.selectedSpot.spot_images.length !== 0) {
        return this.selectedSpot.spot_images[0].image_url;
      }
      return undefined;
    },
    stars() {
      if (!this.comments || this.comments.length === 0) return;
      const numbers = this.comments.map((comment) => comment.Reputation);
      const sum = numbers.reduce((x, y) => x + y);
      return sum / numbers.length;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";

.title-area {
  background: #5cd5d6;
  margin-bottom: 2.5rem;
  height: 35vh;
  position: relative;
  img {
    position: absolute;
    height: 100%;
    width: 100%;
    object-fit: cover;
    top: 0;
    left: 0;
    z-index: 0;
  }
  .star-area {
    display: flex;
    font-size: 0.9rem;
  }

  .stars {
    display: flex;
    flex-direction: row;
    font-size: 0.9rem;
    margin-right: 0.5rem;
    .colored {
      color: #f5d85c;
    }
  }
  .name-area {
    width: calc(100% - 1rem * 2);
    color: white;
    position: absolute;
    top: 16vh;
    z-index: 1;
    left: 1rem;
    p {
      margin: 0;
    }
    .title-name {
      margin-top: 0.25rem;
    }

    .category {
      font-size: 0.8rem;
    }
  }
  .checkin-area {
    position: absolute;
    bottom: -2.5rem;
    width: calc(100% - 1rem * 2);
    margin: 0 16px 0 16px;
    display: flex;
    justify-content: space-between;
    border-radius: 20px;
    background: #fff;
    box-shadow: 0px 5px 5px 0px rgba(1, 39, 76, 0.14);
    padding: 16px 0;
    backdrop-filter: blur(5px);
    .checkin-item {
      width: 100%;
      text-align: center;
      p {
        margin: 0;
      }
      .unit {
        color: #848a94;
        font-size: 0.75rem;
      }
      &:not(:last-child) {
        border-right: 1px solid #e0e0e0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DropSpotSelectModal/TitleArea.vue